module.exports = __webpack_public_path__ + "static/media/currency_icon.8c52660f.svg";